<template>
  <div class="evidences-main p-40">
    <div class="col-xs-12 col-sm-12 col-md-12  evidences-table mb-25"  v-if="ocpStatus.length" >
           <div class=" d-flex align-items-center attachments-panel-child pt-22 pr-24" role="tab" id="headingOne">
                <div class="d-flex  align-items-center col-xs-6 p-0 attachments-card-outer">
                         <img src="/static/images/icons/info_icon_reg_details.svg" class="pr-4 cursor-pointer" />
                         <span class="m-0 pl-12 evidences-title ">{{$t('OCPProcess')}}</span>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 p-0 d-flex col-gap-44 align-items-center justify-content-end">
                  <button data-toggle="collapse" data-target="#accordionOne" data-parent="#accordion" class="file-upload-chevron">
                    <img src="/static/images/icons/down-arrow-icon.svg" class="downCarret" />
                    <img src="/static/images/icons/down-arrow-icon.svg" class="upCarret" />
                  </button>
                </div>
            </div>
            <div id="accordionOne" class="panel-collapse collapse pt-9" role="tabpanel" aria-labelledby="ocpProcess">
            <div class="col-xs-12 col-sm-12 col-md-12 pl-37 pr-0" id="regulation_table">
                    <div class="pb-24 certificate-block">
                        <span class="m-0 certificate-label">{{ $t('certificateName')}}: </span><span class="certificate-name" :title="ocpStatus[0].certificateName">{{ocpStatus[0].certificateName}}</span>
                    </div>
                    <hr  class="line-one mr-24"/>
                    <div class="d-flex readiness-block">
                    <div>
                      <span class="m-0 certificate-label">{{ $t('readiness')}}:</span>
                        <span v-if="ocpStatus[0].isCompleted"><img src="/static/images/icons/green_check_icon.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('completed')}}</span></span>
                        <span v-else><img src="/static/images/icons/ul_warning.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('incomplete')}}</span></span>
                    </div>
                      <div>
                          <span class="m-0 certificate-label">{{ $t('evidence')}}:</span>
                          <span v-if="ocpStatus[0].isCompleted"><img src="/static/images/icons/green_check_icon.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('uploaded')}}</span></span>
                          <span v-else><img src="/static/images/icons/ul_warning.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('notUploaded')}}</span></span>
                    </div>
                    </div>
                    <hr  class="line-one mr-24"/>
                    <div class="evidence-block">
                      <!-- <p class="evidence mb-12">{{$t('evidence')}}</p> -->
                      <span class="evidence-description">{{$t('evidenceDescription')}}</span>
                      <div>
                      <button class="btn add-evidence-btn" :disabled="ocpStatus[0].addEvidenceStatus" @click="addEvidence()">
                      {{ $t('addEvidence')}}
                      </button>
                       <div>
                         <span v-if="ocpStatus[0].addEvidenceStatus"><img src="/static/images/icons/green_check_icon.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('added')}}</span></span>
                          <span v-else><img src="/static/images/icons/ul_warning.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('notAdded')}}</span></span>
                          <span v-if="ocpStatus[0].addEvidenceStatus"> <span class="m-0 product_name pt-10"><span class="fw-400 font-18"> (</span><span class="fw-600 font-16">{{
                           $t('serviceProvider') }}: </span><span class="fw-400 font-16"
                           >{{ocpStatus[0].serviceProvider  }}</span> <span class="fw-400 font-18">)</span> </span></span>
                       </div>
                       <hr  class="bottom-line "/>
                      </div>
                    </div>
                    <div class=" d-flex align-items-center attachments-panel-child pt-22 pl-8 pr-24" role="tab" id="ocpProcess">
                        <div class="d-flex  align-items-center col-xs-9 p-0 attachments-card-outer">
                         <span class="m-0 evidence"> {{$t('manageEvidence')}}</span>
                      </div>
                    <div class="col-xs-3 col-sm-3 col-md-3 p-0 d-flex col-gap-52 justify-content-end">
                    <button class="btn btn-deselect-all p-0 d-flex align-items-center pr-6 " :disabled="disableDelete()" @click="showDeletePopup('', 'ocp')">
                    <img src="/static/images/icons/UL_trash_icon.svg" class="save" />
                    <span class="delete-file">{{ $t('delete') }}</span></button>
                    <button data-toggle="collapse" data-target="#ocpTable" data-parent="#accordion" class="file-upload-chevron">
                        <img src="/static/images/icons/down-arrow-icon.svg" class="downCarret" />
                        <img src="/static/images/icons/down-arrow-icon.svg" class="upCarret" />
                    </button>
                    </div>
                    </div>
                        <div id="ocpTable" class="panel-collapse collapse pt-26 pl-8 pr-24" role="tabpanel" aria-labelledby="headingTwo">
                            <div class="col-xs-12 p-0 ">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0 search-container-wraper search-outer">
                                <div class="search-container reg-search col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                                <div class="position-relative">
                                    <search-box  v-model="ocpSearchValue" :searchCount="ocpSearchCount" @getList="filterEvidencesList('ocp')"></search-box>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 p-0"  >
                          <table class="table table-responsive registration-data" id="evidencesDataList">

                            <tr class="table-row" >
                              <th class="w-60" >
                                  <div class="checkbox cust_checkbox">
                                          <input
                                            type="checkbox"
                                            class="form-control"
                                            v-model="isSelectAllOcpEvidences"
                                            @change="setIsSelectOcpEvidences"

                                          />
                                          <label></label>
                                </div></th>

                              <th  class="w-25">
                                <div class="d-flex align-items-center">
                                <div class="tableHeader cursor-pointer " @click="ocpData.evidenceName = -(ocpData.evidenceName), sortBy('requirement_name', ocpData.evidenceName)">
                                  <div class="ellipsis header-title" :title="$t('evidenceRequired')">{{$t('evidenceRequired')}}</div>
                                  <div class="arrow" :class="ocpData.evidenceName === 1 ? 'down-arrow' : 'up-arrow'"></div>
                                </div>
                                </div>
                              </th>
                                 <th  class="w-auto">
                                <div class="tableHeader cursor-pointer pl-12" @click="ocpData.documentName = -(ocpData.documentName), sortBy('document_name', ocpData.documentName)">
                                  <div class="ellipsis header-title" :title="$t('documentName')">{{$t('documentName')}}</div>
                                  <div class="arrow" :class="ocpData.documentName === 1 ? 'down-arrow' : 'up-arrow'"></div>
                                </div>
                              </th>
                              <th  class="w-auto" >
                                <div class="tableHeader cursor-pointer pl-12" @click="ocpData.uploadedBy = -(ocpData.uploadedBy), sortBy('user_name', ocpData.uploadedBy)">
                                  <div class="ellipsis header-title" :title="$t('uploadedBy')">{{$t('uploadedBy')}}</div>
                                  <div class="arrow" :class="ocpData.uploadedBy === 1 ? 'down-arrow' : 'up-arrow'"></div>
                                </div>
                              </th>
                                <th >
                                <div class="tableHeader cursor-pointer pl-12" @click="ocpData.status = -(ocpData.status), sortBy('status', ocpData. status)">
                                  <div class="ellipsis header-title" :title="$t('status')">{{$t('status')}}</div>
                                  <div class="arrow" :class="ocpData.status === 1 ? 'down-arrow' : 'up-arrow'"></div>
                                </div>
                              </th>
                              <th  class="pl-12 w-auto"></th>
                              <th  class="pl-12 w-auto"></th>

                            </tr>

                            <tbody ref="tbodyBox" v-if="renderFilterData && renderFilterData.length">
                              <tr class=""
                              :class="selectedOcpEvidences.includes(data.unique_id)?'selected_row':index%2===0?'table_data_part1':'table_data_part2'"
                              v-for="(data, index) in renderFilterData" :key="index">
                              <td  class="checkbox-file w-60"> <div class="checkbox cust_checkbox">
                                            <input
                                              type="checkbox"
                                              class="form-control"
                                              :value="data.unique_id"
                                              v-model="selectedOcpEvidences"
                                              @change="setIsSelectAllOcpEvidences"

                                            />
                                            <label></label>
                                  </div></td>
                                <td class="regulation-data w-25" >
                                  <div class="d-flex align-items-center">

                                  <div class="ellipsis  "><span :title="data.requirement_name">{{ data.requirement_name }}</span></div>
                                  </div>
                              </td>
                                <td  class="ellipsis regulation-data w-auto"><span class="pl-12" :title="data.document_name">{{ data.document_name }}</span></td>
                                <td  class="ellipsis regulation-data  w-auto"><span class="pl-12" :title="data.user_name">{{ data.user_name }}</span></td>
                                <td  class="ellipsis regulation-data upload-status ">
                                  <span class="pl-12">
                                  <img v-if="data.status==='Uploaded' || data.status==='Carregado'" src="/static/images/icons/green_check_icon.svg" class="save" />
                                    <img v-else src="/static/images/icons/ul-error-icon.svg" class="save" />
                                  <span :title="data.status">
                                  {{ data.status }}</span>
                                </span>
                                </td>
                                <td  class="ellipsis regulation-data w-auto ">
                                  <div class="pl-12">
                                    <input type="file" :ref="`headLineFile${data.unique_id}`" :id="`newEvidenceFile${data.unique_id}`" class="hidden"  @change="chooseFile($event,data,index)"/>
                                    <button :for="`newEvidenceFile${data.unique_id}`"   class="btn  p-0 d-flex align-items-center blue_outline_upload_button" :disabled="data.document_name!=='NA'&& data.document_name!=='N/D'" @click="openFileUpload($event,data.unique_id)">
                                      <img src="/static/images/icons/UL_upload.svg" class="" />
                                      <span class="upload-file">{{$t('upload')}}</span>
                                    </button>
                                  </div>
                                </td>
                                <td class="ellipsis regulation-data w-auto"><button  class="btn btn-todo-list p-0 d-flex align-items-center" :disabled="(data.document_name =='NA' ||  data.document_name =='N/D')" @click="showDeletePopup(data, 'ocp') "><img src="/static/images/icons/UL_trash_icon.svg" class="save" />
                                <span class="delete-file">{{$t('delete')}}</span></button></td>
                              </tr>
                            </tbody>
                        </table>
                </div>
                        <div v-if="!renderFilterData.length">
                            <p class="no-records-found">{{$t('noRecordsFound')}}</p>
                        </div>
            </div>
            </div>
            </div>
    </div>

    <div class="col-xs-12 col-sm-12 col-md-12  evidences-table mb-25" v-if="labStatus.length">
           <div class=" d-flex align-items-center attachments-panel-child pt-22 pr-24" role="tab" id="headingThree">
                <div class="d-flex  align-items-center col-xs-6 p-0 attachments-card-outer">
                         <img src="/static/images/icons/info_icon_reg_details.svg" class="pr-4 cursor-pointer" />
                         <span class="m-0 pl-12 evidences-title ">{{$t('labResults')}}</span>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 p-0 d-flex col-gap-44 align-items-center justify-content-end">
                  <button data-toggle="collapse" data-target="#accordionTwo" data-parent="#accordion" class="file-upload-chevron">
                    <img src="/static/images/icons/down-arrow-icon.svg" class="downCarret" />
                    <img src="/static/images/icons/down-arrow-icon.svg" class="upCarret" />
                  </button>
                </div>
            </div>
            <div id="accordionTwo" class="panel-collapse collapse pt-9" role="tabpanel" aria-labelledby="labProcess">
            <div class="col-xs-12 col-sm-12 col-md-12 pl-37 pr-0" id="regulation_table">
                    <div class="pb-24 certificate-block">
                          <span class="m-0 certificate-label">{{ $t('certificateName')}}: </span><span class="certificate-name" :title="labStatus[0].certificateName">{{labStatus[0].certificateName}}</span>
                    </div>
                    <hr  class="line-one mr-24"/>
                      <div class="d-flex align-items-center justify-content-between readiness-block">
                    <div>
                          <span class="m-0 certificate-label">{{ $t('readiness')}}:</span>
                          <span v-if="labStatus[0].isCompleted"><img src="/static/images/icons/green_check_icon.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('completed')}}</span></span>
                          <span v-else><img src="/static/images/icons/ul_warning.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('incomplete')}}</span></span>
                          <span class="m-0 pl-24 certificate-label">{{ $t('evidence')}}:</span>
                          <span v-if="labStatus[0].isCompleted"><img src="/static/images/icons/green_check_icon.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('uploaded')}}</span></span>
                          <span v-else><img src="/static/images/icons/ul_warning.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('notUploaded')}}</span></span>
                    </div>
                      <div>
                            <button class="btn download-btn d-flex col-gap-8 align-items-center" :disabled="!renderLabsData.length||labStatus[0].isCompleted"  @click="OcpMarkAsCompleted">
                          <span :title="$t('markAsCompleted')">{{$t('markAsCompleted')}}</span>
                      </button>
                       </div>
                      </div>
                       <hr  class="line-one mr-24"/>
                    <div class="evidence-block">
                      <span class="evidence-description">{{$t('labDescription')}}</span>
                      <div>
                      <button class="btn add-evidence-btn" :disabled="labStatus[0].addEvidenceStatus" @click="showServiceProvidersPopup()">
                      {{ $t('selectServiceProviderBtn')}}
                      </button>
                       <div>
                         <span v-if="labStatus[0].addEvidenceStatus"><img src="/static/images/icons/green_check_icon.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('added')}}</span></span>
                          <span v-else><img src="/static/images/icons/ul_warning.svg" class="pb-4 plr-8" /><span  class="certificate-name">{{$t('notAdded')}}</span></span>
                          <span v-if="labStatus[0].addEvidenceStatus"> <span class="m-0 product_name pt-10"><span class="fw-400 font-18"> (</span><span class="fw-600 font-16">{{
                           $t('serviceProvider') }}: </span><span class="fw-400 font-16"
                           >{{labStatus[0].serviceProvider  }}</span> <span class="fw-400 font-18">)</span> </span></span>
                       </div>
                       </div>
                      </div>
                        <hr  class="bottom-line "/>
                    <div class=" d-flex align-items-center attachments-panel-child pt-22 pl-8 pr-24" role="tab" id="labProcess">
                        <div class="d-flex  align-items-center col-xs-6 p-0 attachments-card-outer">
                         <span class="m-0 evidence"> {{$t('manageEvidence')}}</span>
                      </div>
                    <div class="col-xs-6 col-sm-6 col-md-6 p-0 d-flex col-gap-52 justify-content-end">
                        <input type="file" ref="ocpfile" id="newOcpFile" class="hidden"  @change="selectFile()"/>
                          <button for="newOcpFile" class="btn  p-0 d-flex align-items-center blue_outline_upload_button" :disabled="labStatus[0].isCompleted || !labStatus[0].addEvidenceStatus" @click="openLabsFileUpload($event)">
                            <img src="/static/images/icons/UL_upload.svg" class="" />
                            <span class="upload-file">{{$t('upload')}}</span>
                        </button>
                          <button class="btn btn-deselect-all p-0 d-flex align-items-center pr-6 " :disabled="selectedLabEvidences.length<2 || labStatus[0].isCompleted" @click="showDeletePopup('', 'labs')">
                          <img src="/static/images/icons/UL_trash_icon.svg" class="save" />
                          <span class="delete-file">{{ $t('delete') }}</span></button>
                          <button data-toggle="collapse" data-target="#labTable" data-parent="#accordion" class="file-upload-chevron">
                              <img src="/static/images/icons/down-arrow-icon.svg" class="downCarret" />
                              <img src="/static/images/icons/down-arrow-icon.svg" class="upCarret" />
                          </button>
                    </div>
                    </div>
                        <div id="labTable" class="panel-collapse collapse pt-26 pl-8 pr-24" role="tabpanel" aria-labelledby="headingTwo">
                            <div class="col-xs-12 p-0 ">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0 search-container-wraper search-outer">
                                <div class="search-container reg-search col-xs-12 col-sm-12 col-md-12 col-lg-12 p-0">
                                <div  class="position-relative">
                                    <search-box  v-model="labSearchValue" :searchCount="labSearchCount" @getList="filterEvidencesList('lab')"></search-box>
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 p-0"  >
                            <table class="table table-responsive registration-data" id="evidencesDataList">

            <tr class="table-row" >
              <th class="w-60"  >
                  <div class="checkbox cust_checkbox">
                          <input

                            type="checkbox"
                            class="form-control"
                            v-model="isSelectAllLabEvidences"
                             @change="setIsSelectLabEvidences"

                          />
                          <label></label>
                 </div></th>
              <th >
                <div class="tableHeader cursor-pointer" @click="labData.documentName = -(labData.documentName), sortBy('document_name', labData.documentName, true)">
                  <div class="ellipsis header-title" :title="$t('documentName')">{{$t('documentName')}}</div>
                  <div class="arrow" :class="labData.documentName === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
                 <th >
                <div class="tableHeader cursor-pointer" @click="labData.uploadedBy = -(labData.uploadedBy), sortBy('user_name', labData.uploadedBy, true)">
                  <div class="ellipsis header-title pl-12" :title="$t('uploadedBy')">{{$t('uploadedBy')}}</div>
                  <div class="arrow" :class="labData.uploadedBy === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th >
                <div class="tableHeader cursor-pointer" @click="labData.status = -(labData.status), sortBy('status', labData. status,true)">
                  <div class="ellipsis header-title pl-12" :title="$t('status')">{{$t('status')}}</div>
                  <div class="arrow" :class="labData.status === 1 ? 'down-arrow' : 'up-arrow'"></div>
                </div>
              </th>
              <th></th>
            </tr>

          <tbody ref="tbodyBox" v-if="renderLabsData && renderLabsData.length">
            <tr class=""
            :class="selectedLabEvidences.includes(data.unique_id)?'selected_row':index%2===0?'table_data_part1':'table_data_part2'"
            v-for="(data, index) in renderLabsData" :key="index">
            <td  class="checkbox-file w-60"> <div class="checkbox cust_checkbox">
                          <input
                            type="checkbox"
                            class="form-control"
                            :value="data.unique_id"
                            v-model="selectedLabEvidences"
                            @change="setIsSelectAllLabEvidences"

                          />
                          <label></label>
                 </div></td>
             <td  class="ellipsis regulation-data"><span :title="data.document_name">{{ data.document_name }}</span></td>
              <td  class="ellipsis regulation-data"><span class="pl-12" :title="data.user_name">{{ data.user_name }}</span></td>
              <td  class="ellipsis regulation-data upload-status">
                <span class="pl-12">
                <img v-if="data.status==='Uploaded' || data.status==='Carregado'" src="/static/images/icons/green_check_icon.svg" class="save" />
                  <img v-else src="/static/images/icons/ul-error-icon.svg" class="save" />
                <span :title="data.status">
                {{ data.status }}</span>
              </span>
              </td>
              <td  class="ellipsis regulation-data">
                <div class="pl-12">
                  <button  class="btn btn-todo-list p-0 d-flex align-items-center" @click="showDeletePopup(data, 'labs') " :disabled="labStatus[0].isCompleted"><img src="/static/images/icons/UL_trash_icon.svg" class="save" />
                  <span class="delete-file">{{$t('delete')}}</span></button>
                </div>
            </td>
             </tr>
          </tbody>
        </table>
                      </div>
                        <div v-if="!renderLabsData.length">
                            <p class="no-records-found">{{$t('noRecordsFound')}}</p>
                        </div>
            </div>
            </div>
            </div>
    </div>
    <confirmation-popup :title="deleteRecords" :confirmationText="confirmationText"  @proceedChanges="deleteFile"></confirmation-popup>
    <loader :loadingStatus="loaderStatus"></loader>
    <add-evidence @loadData="loadData" :ocpData="ocpStatus"></add-evidence>
    <service-provider-popup @loadLabsData="loadLabsData" :labsData="labStatus"></service-provider-popup>

 </div>

</template>
<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';
import Loader from '../UIComponents/Loader.vue';
import SearchBox from '../UIComponents/ULSearchBox.vue';
import ConfirmationPopup from '../Common/ULConfirmationPopup.vue';
import AddEvidence from './AddEvidence.vue';
import ServiceProviderPopup from './ServiceProviderPopup.vue';
import {
  getOcpDocuments, getEvidence, deleteEvidenceDocument, uploadDocument, uploadOcpDocument, deleteOcpDocument
} from '../../apis/evidence';
import { getReadinessDetails, markAsCompleted } from '../../apis/ToDoList';

export default {
  components: {
    SearchBox,
    Loader,
    EventBus,
    ConfirmationPopup,
    AddEvidence,
    ServiceProviderPopup
  },
  props: { nextBtn: String },
  watch: {
    nextBtn() {
      if (this.nextBtn === 'evidence') {
        this.$emit('submit');
        this.$router.push(
          `/layout/registration/flow/final-review/${this.$route.params.id}`
        );
      }
    },
  },
  data() {
    return {
      ocpSearchValue: '',
      labSearchValue: '',
      renderFilterData: [],
      renderLabsData: [],
      ocpData: {
        evidenceName: 1,
        uploadedBy: 1,
        documentName: 1,
        status: 1,
      },
      labData: {
        uploadedBy: 1,
        documentName: 1,
        status: 1,
      },
      labSearchCount: 0,
      ocpSearchCount: 0,
      filteredOcpData: [],
      filteredLabsData: [],
      loaderStatus: true,
      isPreviouslySearched: false,
      isSelectAllEvidences: false,
      deleteRecords: '',
      confirmationText: this.$i18n.locale === 'Portuguese' ? 'Você está prestes a excluir os documentos. Uma vez excluído, você não poderá recuperar as informações.' : 'Your are about to delete the documents. Once deleted, you will not be able to recover the information.',
      deleteData: [],
      registrationId: '',
      regulationId: '',
      ocpStatus: [],
      labStatus: [],
      category: '',
      selectedLabEvidences: [],
      selectedOcpEvidences: [],
      isSelectAllOcpEvidences: false,
      isSelectAllLabEvidences: false
    };
  },
  methods: {
    disableDelete() {
      let count = 0;
      let response = [];
      this.selectedOcpEvidences.forEach((item) => {
        response = this.filteredOcpData.find((evidence) => evidence.unique_id === item && evidence.user_name);
        // eslint-disable-next-line no-unused-expressions, no-plusplus
        response ? count++ : '';
      });
      return count < 2;
    },
    async loadData() {
      await this.getReadinessDetails('ocp');
      await this.getOcpDocuments();
    },
    async loadLabsData() {
      await this.getReadinessDetails('');
      await this.getLabDocuments();
    },
    async OcpMarkAsCompleted() {
      const payload = {
        registration_id: this.registrationId,
        regulation_id: this.regulationId,
      };
      const response = await markAsCompleted(payload);
      if (response.status === 204) {
        await this.getReadinessDetails('');
      }
    },
    async getReadinessDetails(type) {
      this.loaderStatus = true;
      const payload = [{ productRegistrationId: this.registrationId, evidenceType: type === 'ocp' ? 'EVD_OCP' : '' }];
      const response = await getReadinessDetails(payload);
      this.loaderStatus = false;
      // eslint-disable-next-line no-unused-expressions
      type === 'ocp' ? this.ocpStatus = response : this.labStatus = response;
      this.regulationId = this.ocpStatus[0].regulationId;
    },
    addEvidence() {
      $('#addEvidence').modal('show');
    },
    showServiceProvidersPopup() {
      $('#serviceProviders').modal('show');
    },
    openLabsFileUpload() {
      $('#newOcpFile').click();
    },
    openFileUpload(event, id) {
      $(`#newEvidenceFile${id}`).click();
    },
    async chooseFile(event, evidenceData, recordIndex) {
      let input = this.$refs[`headLineFile${evidenceData.unique_id}`][0].files[0];
      if (input) {
        const fileExtension = (input.name.split('.'))[input.name.split('.').length - 1];
        const result = this.checkFileValidations(input, fileExtension);
        if (!result) {
          this.renderFilterData[recordIndex].document_name = input.name;
          const formData = new FormData();
          formData.append('file', input);
          formData.append('requirementId', evidenceData.requirement_id);
          formData.append('regulationId', evidenceData.regulation_id);
          formData.append('registrationId', evidenceData.registration_id);
          formData.append('uniqueId', evidenceData.unique_id);
          this.loaderStatus = true;
          const response = await uploadOcpDocument(formData);
          if (response.status_code === 200) {
            await this.getReadinessDetails('ocp');
            await this.getOcpDocuments();
            this.loaderStatus = false;
            this.clearNotifications();
            this.$notify({
              type: 'success',
              title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
              text: this.$i18n.locale === 'English' ? 'The required documents are submitted successfully.' : 'Os documentos necessários foram enviados com sucesso .',
              group: 'custom-notification',
            });
          }
        }
        input = null;
        this.$refs[`headLineFile${evidenceData.unique_id}`][0].value = '';
      }
    },
    async selectFile(event) {
      let input = this.$refs.ocpfile.files[0];
      console.log('selectFile', event, input.size);
      if (input) {
        const fileExtension = (input.name.split('.'))[input.name.split('.').length - 1];
        const result = this.checkFileValidations(input, fileExtension);
        if (!result) {
          const formData = new FormData();
          formData.append('file', input);
          formData.append('regulationId', this.labStatus[0].regulationId);
          formData.append('registrationId', this.labStatus[0].productRegistrationId);
          this.loaderStatus = true;
          const response = await uploadDocument(formData);
          if (response.status_code === 200) {
            input = null;
            this.$refs.ocpfile.value = '';
            await this.getLabDocuments();
            this.loaderStatus = false;
            this.clearNotifications();
            this.$notify({
              type: 'success',
              title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
              text: this.$i18n.locale === 'English' ? 'The required documents are submitted successfully.' : 'Os documentos necessários foram enviados com sucesso.',
              group: 'custom-notification',
            });
          } else {
            input = null;
            this.$refs.ocpfile.value = '';
            this.loaderStatus = false;
            this.clearNotifications();
            this.$notify({
              type: 'error',
              title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
              text: this.$i18n.locale === 'English' ? 'Document with same name already exists. Please rename the file and upload again.' : 'Já existe um documento com o mesmo nome. Por favor, renomeie o arquivo e faça o upload novamente.',
              group: 'custom-notification',
            });
          }
        }
        input = null;
        this.$refs.ocpfile.value = '';
      }
    },
    checkFileValidations(input, fileExtension) {
      if (input.size > 10000000) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'O tamanho do arquivo não pode exceder 10 MB' : 'File size cannot exceed 10MB',
          group: 'custom-notification',
        });
        return true;
      } if (!['pdf', 'jpeg', 'png', 'raw', 'ai', 'psd', 'PDF', 'JPEG', 'PNG', 'RAW', 'AI', 'PSD'].includes(fileExtension)) {
        this.clearNotifications();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'O arquivo deve ser do tipo jpeg /png /pdf /ai /psd /raw' : 'File should be of type jpeg /png /pdf /ai /psd /raw',
          group: 'custom-notification',
        });
        return true;
      }
      return false;
    },
    clearNotifications() {
      this.$notify({
        clear: true,
        group: 'custom-notification',
      });
    },
    showDeletePopup(data, category) {
      this.deleteRecords = this.$i18n.locale === 'Portuguese' ? 'Excluir registros' : 'Delete Records';
      this.confirmationText = this.$i18n.locale === 'Portuguese' ? 'Você está prestes a excluir os documentos. Uma vez excluído, você não poderá recuperar as informações.' : 'Your are about to delete the documents. Once deleted, you will not be able to recover the information.';
      $('#deleteRecord').modal('show');
      // eslint-disable-next-line no-unused-expressions
      data ? this.deleteData.push(data) : '';
      this.category = category;
    },
    async deleteFile() {
      this.loaderStatus = true;
      $('#deleteRecord').modal('hide');
      const records = this.category === 'ocp' ? this.selectedOcpEvidences : this.selectedLabEvidences;
      let payload = '';
      payload = {
        unique_ids: this.deleteData.length ? [this.deleteData[0].unique_id] : records,
      };
      const response = this.category === 'ocp' ? await deleteOcpDocument(payload) : await deleteEvidenceDocument(payload);
      if (response.status === 204) {
        this.loaderStatus = false;
        this.deleteData = [];
        // eslint-disable-next-line no-unused-expressions
        if (this.category === 'ocp') {
          this.selectedOcpEvidences = [];
          this.isSelectAllOcpEvidences = false;
          await this.getReadinessDetails('ocp');
          await this.getOcpDocuments();
        } else {
          this.selectedLabEvidences = [];
          this.isSelectAllLabEvidences = [];
          await this.getLabDocuments();
        }
        this.$notify({
          type: 'success',
          title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
          text: this.$i18n.locale === 'English' ? 'The selected documents are deleted successfully.' : 'Os documentos necessários foram enviados com sucesso.',
          group: 'custom-notification',
        });
      } else {
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: this.$i18n.locale === 'Portuguese' ? 'Falha ao excluir documentos.' : 'Failed to delete documents.',
          group: 'custom-notification',
        });
      }
    },

    setIsSelectAllOcpEvidences() {
      this.isSelectAllOcpEvidences = this.selectedOcpEvidences.length === this.renderFilterData.length;
    },
    setIsSelectAllLabEvidences() {
      this.isSelectAllLabEvidences = this.selectedLabEvidences.length === this.renderLabsData.length;
    },
    setIsSelectLabEvidences(type) {
      if (type === 'deselect') { this.isSelectAllLabEvidences = false; }
      if (this.isSelectAllLabEvidences) this.selectedLabEvidences = this.renderLabsData.map((evidence) => evidence.unique_id);
      else this.selectedLabEvidences = [];
    },
    setIsSelectOcpEvidences(type) {
      if (type === 'deselect') { this.isSelectAllOcpEvidences = false; }
      if (this.isSelectAllOcpEvidences) this.selectedOcpEvidences = this.renderFilterData.map((evidence) => evidence.unique_id);
      else this.selectedOcpEvidences = [];
    },
    async getOcpDocuments() {
      const response = await getOcpDocuments(this.registrationId, this.regulationId);
      if (response) {
        this.renderFilterData = response;
        this.loaderStatus = false;
        if (this.renderFilterData) {
          this.filteredOcpData = this.renderFilterData;
          this.ocpSearchCount = this.renderFilterData.length;
        }
      }
    },
    async getLabDocuments() {
      const response = await getEvidence(this.registrationId, this.regulationId);
      if (response) {
        this.renderLabsData = response;
        this.loaderStatus = false;
        if (this.renderLabsData) {
          this.filteredLabsData = this.renderLabsData;
          this.labSearchCount = this.renderLabsData.length;
        }
      }
    },
    sortBy(type, direction, isLab) {
      const data = isLab ? this.renderLabsData : this.renderFilterData;
      if (direction === 1) data.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        data.sort((a, b) => {
          if (a[type] === null) {
            a[type] = '';
          } else if (b[type] === null) {
            b[type] = '';
          }
          const firstElement = a[type].toUpperCase(); // ignore upper and lowercase
          const secondElement = b[type].toUpperCase(); // ignore upper and lowercase

          if (firstElement < secondElement) {
            return -1;
          }
          if (firstElement > secondElement) {
            return 1;
          }
          return 0;
        });
      }
    },
    filterEvidencesList(type) {
      if (this.ocpSearchValue || this.labSearchValue) {
        this.filterEvidences(type);
        this.isPreviouslySearched = true;
      } else if (this.isPreviouslySearched) {
        this.filterEvidences(type);
        this.isPreviouslySearched = false;
      }
    },
    async filterEvidences(type) {
      const searchStr = type === 'ocp' ? this.ocpSearchValue.trim() : this.labSearchValue.trim();
      this.renderFilterData = [];
      if (!searchStr.length) {
        if (type === 'ocp') this.renderFilterData = this.filteredOcpData;
        else this.renderLabsData = this.filteredLabsData;
        this.ocpSearchCount = this.renderFilterData.length;
        this.labSearchCount = this.renderLabsData.length;
        return;
      }
      if (type === 'ocp') {
        this.renderFilterData = this.filteredOcpData.filter((each) => this.searchString(searchStr, each, 'ocp'));
        this.ocpSearchCount = this.renderFilterData.length;
      } else {
        this.renderLabsData = this.filteredLabsData.filter((each) => this.searchString(searchStr, each));
        this.labSearchCount = this.renderLabsData.length;
      }
    },
    searchString(searchValue, evidenceData, type) {
      if (type === 'ocp' && (evidenceData.requirement_name.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((evidenceData.document_name.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((evidenceData.user_name.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      if ((evidenceData.status.toLowerCase()).indexOf(searchValue.toLowerCase()) !== -1) {
        return true;
      }
      return false;
    },

  },
  async created() {
    EventBus.$on('updateLanguage', (language, oldLanguage) => {
      if (language !== oldLanguage) {
        this.$router.go();
      }
    });
    $(() => {
      $('#accordionOne').collapse('show');
      $('#ocpTable').collapse('show');
    });
    if (this.$route.params.id) {
      this.registrationId = this.$route.params.id;
    }
    this.$emit('disableSaveBtn', false);
    await this.getReadinessDetails('ocp');
    await this.getReadinessDetails('');
    await this.getOcpDocuments();
    await this.getLabDocuments();
  },
  beforeDestroy() {
    EventBus.$off('updateLanguage');
  },

};
</script>
<style scoped>
.w-auto {
  width:auto;
}
.w-25 {
  width:20%;
}
.w-60 {
  width:60px;
}
.table-row {
  background-color: #E6E6E6;
}
.col-gap-52 {
  column-gap: 52px;
}
.mb-12 {
  margin-bottom: 12px;
}
.mb-25 {
  margin-bottom: 25px;
}

.p-40 {
  padding: 40px;
}
.add-evidence-btn,
.add-evidence-btn:hover {
  background-color: #ffffff;
  border-radius: 3px;
  border: 1px solid #000001;
  min-height: 44px;
  min-width: 172px;
  color: #000000 !important;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  padding: 9px 16px;
  margin:24px 0px 28px 5px;
}
.evidence{
color: #3E3E3E;
font-size: 18px;
font-weight: 600;
}
.evidence-block {
  margin-bottom: 12px;
  padding-top:21px
}
.evidence-description{
color: #3E3E3E;
font-family: Open Sans;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: normal;
padding-left:4px;
}
.plr-8 {
  padding-left: 8px;
  padding-right: 8px;
}
.readiness-block{
  padding-top:15px;
  padding-bottom: 10px;
  column-gap: 28px;
}
.pl-28 {
  padding-left: 28px;
}
.download-btn {
  background-color: #ffffff;
  border-radius: 3px;
  border: 1px solid #000001;
  min-height: 44px;
  /* min-width: 172px; */
  color: #000000 !important;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  padding: 9px 16px;
  margin-right:54px;
}
.file-upload-chevron {
  border: none;
  background-color: transparent !important;
}
button[aria-expanded="true"] img.upCarret {
  display: inline-block;
}
button[aria-expanded="true"] img.downCarret {
  display: none;
}
button img.downCarret {
  display: inline-block;
  transform: rotate(180deg);
  /* width: 10px;
  height: 10px; */
}
button img.upCarret {
  display: none;
  /* width: 10px;
  height: 10px; */
}
input[type="file"] {
    display: none;
}
.pl-37 {
    padding-left: 37px;
}
.certificate-label{
color: #3E3E3E;
font-family: Open Sans;
font-size: 16px;
font-style: normal;
font-weight: 600;
}
.certificate-name{
color: #3E3E3E;
font-family: Open Sans;
font-size: 16px;
font-style: normal;
font-weight: 400;
}
.line-one {
  border-top: 1px solid #D3D3D3;
  margin-top: 0px;
  margin-bottom: 0px;
}
.mr-24 {
  margin-right: 48px;
}
.pl-8{
  padding-left: 8px;
}
.pl-12 {
  padding-left: 12px !important;
}
.bottom-line {
  border-top: 1px solid #D3D3D3;
  margin: 24px 12px 24px 5px;
}
.product-info {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.pt-26 {
  padding-top:26px;
}

.selected_row {
  background: #ECF5FC;
}
.file-upload-hide{
  margin: 0 auto;
  width:170px;
}
/* .table>tbody>tr>td{
  padding:0px !important
} */
.cancel_ul_button,
.cancel_ul_button:hover {
  background-color: #FFFFFF;
  border-radius: 3px;
  border: 1px solid #000001;
  min-height: 44px;
  min-width: 90px;
  color: #000000;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 25px;
  /* float: right; */
  /* cursor: pointer; */
  padding: 6px 16px;
}
.save_ul_button,
.save_ul_button:hover {
  background-color: #01518A;
  border-radius: 3px;
  /* border: 1px solid #000001; */
  min-height: 44px;
  min-width: 94px;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 25px;
  padding: 6px 16px;
}
#regulation_table::-webkit-scrollbar {
  /* padding-top:50px; */
  width: 6px;
  /* height: 400px; */
}
#regulation_table::-webkit-scrollbar-thumb {
  background: #CCCCCC;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  /* height: 400px; */
}
#regulation_table {
  margin-bottom: 10px;
  max-height: calc(100vh - 252px);
  overflow-y: auto;
  overflow-x: hidden;
}
.pr-6 {
  padding-right:6px
}
.pr-44 {
  padding-right: 44px;
}
.pl-4 {
  padding-left:4px
}
.col-gap-44 {
  column-gap: 44px;
}
.btn-deselect-all {
  background: none;
  /* padding-bottom: 4px; */
}
.upload-status {
    display: flex;
    align-items: center;
    column-gap: 12px;
}
.deSelect {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #01518A;

}
.delete-file {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #C02032;
  padding-left:4px

}
.evidence-required {
  padding:14px 0px 16px 0px !important;
}

.checkbox {
    position: relative;
}

input[type="checkbox"] {
    opacity: 0;
    cursor: pointer;
    position: absolute;
    z-index: 1;
    width: 18px !important;
    height: 18px !important;
    left: 0;
    top: 0;
    margin: 0 !important;
}

.checkbox label:before {
    content: "";
    width: 18px !important;
    height: 18px !important;
    border: 2px solid #000000;;
    display: inline-block;
    position: absolute;
    left: 0;
    top: -2px;
    border-radius: 3px;
}

.checkbox input[type="checkbox"]:checked+label:before {
    background-color: #01518A;
    background-image: url(/static/images/icons/checkbox.svg);
    background-size: 12px 15px;
    background-repeat: no-repeat;
    background-position-x: center;
    border: none;

}
/* .tbody.checkbox label{
  top: 7px !important;
} */
.checkbox label {
    cursor: auto;
    top: 5px;
    position: relative;
}

.cust_checkbox {
    /* margin: 0px; */
    margin: 0px 13px 0px 15px;
    display: inline-block;
}
.upload-evidence {
    font-weight: 700;
    font-size: 18px;
    line-height: 34px;
    color: #3E3E3E;
}
.evidence-info {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding-bottom:23px
}
.pl-70 {
    padding-left:70px;
}
.pr-64 {
    padding-right: 64px;
}
.evidences-table {
    background-color: #FFFFFF;
    border: 1px solid #B3B3B3;
    padding:16px 0px 16px 15px;
}
.footer {
  left:200px;
  padding:24px 24px 24px 7px;
  /* padding-top: 24px; */
  position: absolute;
  bottom: 1px;
  right: 1px;
  background: #FFFFFF;
  border: 1px solid #B3B3B3;
}
.ul_finish_button,
.ul_finish_button:hover {
  background-color: #01518A;
  height: 34px;
  width: 123px;
  color: #FFFFFF !important;
  font-size: 16px;
  font-weight: 600;
  border-radius: 3px;
  line-height: 22px;
  float: right;
  cursor: pointer;
  padding: 6px 16px 6px 16px;
}
.blue_outline_upload_button {
   background: none;
}
.evidences-header {
  padding:24px 0px 0px 30px
}
.btn-todo-list,
.btn-todo-list:hover {
  background: none;
  /* font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #01518A; */
  /* padding-bottom: 4px; */
}
.table_data_part1{
  background-color: #FAFAFA;
}
.table_data_part2{
  background-color: #F5F5F5;
}
.certificate-block {
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   padding-right: 50px;
}
.pb-24 {
  padding-bottom: 24px;
}
.pb-14 {
  padding-bottom: 14px;
}
.header-title{
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
}
.regulation-data {
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 16px 0px !important;
}
.upload-file {
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #01518A;
  padding-left: 4px;

}
.checkbox-file {

  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3E3E3E;
  padding: 14px 0px 0px 0px !important;

}
.down-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 7px solid #999999;
}

.up-arrow {
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #999999;
}

.evidences-main {
    /* background-color: #F5F5F5 !important; */
  height: calc(100vh - 24px) !important;
}
.evidences-title {
  font-weight: 400;
  font-size: 24px;
  line-height: 34px;
  color: #3E3E3E;
}
.tableHeader {
  display: flex;
  align-items: center;
  padding:14px 0px 12px 0px;
  column-gap: 7px
  /* justify-content: center; */
}
.table > tbody > tr > td {
  /* padding: 0px !important; */
   /* padding: 14px 0px 16px 12px !important; */
  word-break: break-word;
}
.evidencesBackground {
  background-color: #ebebeb
}
#evidencesDataList th .arrow {
  opacity: 1;
}
#evidencesDataList thead,

#evidencesDataList tbody,

#evidencesDataList tr:not(#evidencesDataList thead tr) {
 display: table;
 width: 100%;
table-layout: fixed;
}
@media only screen and (max-width: 1300px) {
  .footer{
    left: 1px !important;
}
}
</style>
